import { ChangeDetectionStrategy, Component, ViewChild, inject } from '@angular/core';
import { I18NextPipe } from 'angular-i18next';
import { ButtonComponent, ModalComponent, ModalFooterDirective, ToastService } from 'mbs-ui-kit';
import { Observable, finalize, take } from 'rxjs';

export enum PrePostActionsVerificationAnswer {
  RequestVerification = 'requestVerification',
  DisablePrePostActions = 'disablePrePostActions'
}

@Component({
  selector: 'mbs-pre-post-actions-verification-modal',
  templateUrl: './pre-post-actions-verification-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonComponent, I18NextPipe, ModalComponent, ModalFooterDirective]
})
export class PrePostActionsVerificationModalComponent {
  private toastService = inject(ToastService);
  private i18n = inject(I18NextPipe);

  public readonly answer = PrePostActionsVerificationAnswer;
  public loading = false;

  @ViewChild(ModalComponent, { static: true }) baseModal: ModalComponent;

  get email(): string {
    return this.baseModal.data?.email ?? '';
  }

  requestVerification(): void {
    this.loading = true;

    const request = this.baseModal.data.request as Observable<unknown>;

    request
      .pipe(
        take(1),
        finalize(() => (this.loading = false))
      )
      .subscribe({
        next: () => {
          this.toastService.success(this.i18n.transform('shared:accessReview.sendSuccess', { email: this.email }));
          this.baseModal.save(PrePostActionsVerificationAnswer.RequestVerification);
        },
        error: (err) => {
          const reason = err?.error?.message || err?.error?.title || err?.message || '';
          this.toastService.error(this.i18n.transform('shared:accessReview.sendError', { email: this.email, reason }));
        }
      });
  }
}
